import React from 'react';

import { Svg, type SvgProps } from './svg';

export function ExpandIcon(props: SvgProps) {
  return (
    <Svg data-testid="expand-icon" {...props}>
      <path d="M22 10.8889V2H13.1111L16.7667 5.65556L5.65556 16.7667L2 13.1111V22H10.8889L7.23333 18.3444L18.3444 7.23333L22 10.8889Z" />
    </Svg>
  );
}
